module.exports = __webpack_public_path__ + "static/media/ttt.ba7031c6.png";